export default [
  {
    path: '/message-group',
    name: 'messageGroups',
    component: () => import('@/views/menu/messenger/messageGroup/messageGroups.vue'),
    meta: {
      pageTitle: 'مدیریت گروه های چت',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/message-group/add',
    name: 'addMessageGroup',
    component: () => import('@/views/menu/messenger/messageGroup/messageGroupItem.vue'),
    meta: {
      pageTitle: 'ایجاد گروه چت جدید',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/message-group/edit/:id',
    name: 'updateMessageGroup',
    component: () => import('@/views/menu/messenger/messageGroup/messageGroupItem.vue'),
    meta: {
      pageTitle: 'ویرایش گروه چت',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/message-group-user',
    name: 'messageGroupUsers',
    component: () => import('@/views/menu/messenger/messageGroupUser/messageGroupUsers.vue'),
    meta: {
      pageTitle: 'کاربران گروه',
      action: 'show',
      resource: 'BlogManager',
    }
  },
  {
    path: '/message-report',
    name: 'messageReports',
    component: () => import('@/views/menu/messenger/messageReport/messageReports.vue'),
    meta: {
      pageTitle: 'پیام های گزارش شده',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/scheduleMessage',
    name: 'scheduleMessage',
    component: () => import('@/views/menu/messenger/scheduleMessage/scheduleMessage.vue'),
    meta: {
      pageTitle: 'پیام های زمان بندی شده',
      action: 'show',
      resource: 'BlogManager',
    },
  },
{
    path: '/scheduleDetails/:id',
    name: 'scheduleDetails',
    component: () => import('@/views/menu/messenger/scheduleMessage/scheduleDetails.vue'),
    meta: {
      pageTitle: 'پیام های زمان بندی شده',
      action: 'show',
      resource: 'BlogManager',
    },
  },

]